angular.module("warsApp.filters").filter('startFrom', function () {
    return function (input, start) {
        if (input == undefined) return null;
        return input.slice(start);
    }
});